export const commonModelSlugs = [
    "anthropic/claude-3-7-sonnet",
    "togetherai/llama-4-maverick-instruct-17bx128e",
    "google/gemini-2.5-pro",
    "mistral/codestral",
    "voyageai/voyage-code-3",
    "relace/instant-apply",
    "xai/grok-2",
    "openai/gpt-4o",
    "togetherai/llama-4-scout-instruct-17bx16e",
    "anthropic/claude-3-5-sonnet",
    "google/gemini-2.0-flash",
    "voyageai/rerank-2",
    "ollama/deepseek-r1",
    "morphllm/morph-v0",
    "anthropic/claude-3-5-haiku",
    "lmstudio/deepseek-r1",
    "openai/o3-mini",
    "voyageai/voyage-code-2",
    "ollama/qwen2.5-coder-1.5b",
    "openai/gpt-4o-mini",
    "openai/o1",
    "mistral/mistral-embed",
    "ollama/nomic-embed-text-latest",
    "lmstudio/deepseek-r1-8b",
    "mistral/mistral-large",
    "lmstudio/qwen2.5-coder-1.5b",
    "ollama/deepseek-r1-8b",
    "openai/text-embedding-3-large",
];
//# sourceMappingURL=commonSlugs.js.map